import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm} from 'redux-form';

import SmallLoader from '../../../../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect } from "../../../../../../../components/reduxFields";
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from "../../../../../../../components/buttons";
import Divider from "material-ui/Divider";
import validate from "./validate";
import { getSkillAcquisitionDomainList, movePatientSkillAcquisitionData, getSkillAcquisitionProgramList,getSkillAcquisitionProgramListForMoveData, ResetMoveData} from "./actions/skillAquisitionDomainActions";
import { getSkillAcquisitionTargetList } from "../Target/actions/skillAquisitionTargetActions";

class MoveDomainModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            programData : [],
            targetData: [],
            domainData: [],
            moveProgramData : [],
            selectedProgram : 0,
            selectedDomain : 0,
            targetID : 0,
            selectedMoveProgram : 0,
            skillAcquisitionDomainId :null,
            programError : false,
            domainSelected : false,
        };
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        
    }

    componentDidMount() {
        if (this.props.skillAcquisitionProgramList !== null && this.props.skillAcquisitionProgramList !== undefined ) {
            let data =this.props.skillAcquisitionProgramList.data.map((obj)=> obj = {...obj ,value:obj.programName})
            this.setState({
                programData : data
            })
        }
        this.loadData();
    }
    

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.skillAcquisitionDomainList !== null &&nextProps.skillAcquisitionDomainList !== undefined ) {
            let data = nextProps.skillAcquisitionDomainList.data.map((obj)=> obj = {...obj ,value:obj.domainName})
            this.setState({
                domainData: data,
            });
        }
        if (nextProps.skillAcquisitionProgramListing && nextProps.skillAcquisitionProgramListing.data && nextProps.skillAcquisitionProgramListing.data.length > 0) {
            let data = nextProps.skillAcquisitionProgramListing.data.map((obj) => ({ ...obj, value: obj.programName }));
            this.setState({
                moveProgramData: data,
                programError : false
            });
        }else {
            this.setState({
                moveProgramData: [],
                programError :this.state.domainSelected
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.skillAcquisitionTargetList !== this.props.skillAcquisitionTargetList) {
            this.targetData();
        }
    }
    

    handleClose = (page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        if (this.state.open) {
            this.setState({ open: false , moveProgramData : []});
            this.props.closeDialog();
            this.props.ResetMoveData();
            this.props.getSkillAcquisitionProgramList(searchObj, this.props.patientId, this.props.domainId,false)
        }
    };

    loadData = (page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        this.props.getSkillAcquisitionDomainList(searchObj, this.props.patientId)
        this.props.getSkillAcquisitionProgramList(searchObj, this.props.patientId, this.props.domainId, true);
    }

    handleNewRequestProgram = (input,selected,page_number) => {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        input.onChange(selected.value);
        this.setState({selectedProgram: selected.value},()=>{
            this.props.getSkillAcquisitionTargetList(searchObj, this.props.patientId,this.state.selectedProgram, true)
            this.targetData();
        })
    }

    targetData = () =>{
        if (this.props.skillAcquisitionTargetList !== null &&this.props.skillAcquisitionTargetList !== undefined ) {
            let data = this.props.skillAcquisitionTargetList.data.map((obj)=> obj = {...obj ,value:obj.targetName})
            this.setState({
                targetData: data ,
            });
        }
    }

    handleSelectTarget=(input,selected)=>{
        input.onChange(selected.value)
        this.setState({targetID:selected.value});
    }

    handleDomainNameSelection = (input,selected,page_number) =>{
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: { SearchText: this.filter.searchText || null },
            pageNumber: page_number || 1,
        };
        input.onChange(selected.value);
        this.setState({selectedDomain : selected.value}, () => {
            let selectedDomainId = this.state.domainData.filter((ele)=>ele.id===this.state.selectedDomain);
                if (selectedDomainId.length > 0) {
                    const domainData = selectedDomainId[0];
                    if (domainData.domainId) {
                        this.setState({ skillAcquisitionDomainId: domainData.domainId, domainSelected: true }, () => {
                            this.props.getSkillAcquisitionProgramListForMoveData(searchObj, this.props.patientId, this.state.skillAcquisitionDomainId, true);
                        });
                    } else {
                        this.setState({ moveProgramData: [] }); // Reset moveProgramData if no data
                    }
                } else {
                    this.setState({ moveProgramData: [] }); // Reset moveProgramData if selected domain has no data
                }
        })
    }

    handleProgramNameSelection = (input,selected) => {
        input.onChange(selected.value);
        this.setState({selectedMoveProgram : selected.value})
    }

    onSubmitHandler = async()  => {
        let paramObj = {
            "SkillAcquisitionProgramId": this.state.selectedProgram,
            "SkillAcquisitionTargetId": this.state.targetID,
            "NewSkillAcquisitionDomainId": this.state.selectedDomain,
            "NewSkillAcquisitionProgramId":  this.state.selectedMoveProgram,
            "PatientId": Number(this.props.patientId)
        }
        try{
            await this.props.movePatientSkillAcquisitionData(paramObj);
            this.loadData();
        }catch(error){
            console.error('Error:', error);
        }
        this.setState({ open: false });
        this.props.closeDialog();
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const { handleSubmit } = this.props;
        let submitButton = this.props.loading ?
            <SubmitButtonModalDisabled label="Loading" /> :
            <SubmitButtonModal label="Move" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
            submitButton,
        ];
        return <Dialog className="custom_modal" title="Move to Different Domain/Program" modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
           {this.renderLoading()}
            <div className="row">
                <div className="col-sm-12">
                    <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
                        <div className="row">
                            <div className="mt-30" style={{fontWeight: "bold"}}>Select Program/Target to Move :</div>
                            <div className='col-sm-12 mt-30'>
                                <Field
                                name="programId"
                                label="Program"
                                options={this.state.programData}
                                handleNewRequest={this.handleNewRequestProgram}
                                component={renderAutoCompleteSingleSelect}
                                />
                            </div>
                            <div className='col-sm-12 mt-30'>
                                <Field
                                name="targetId"
                                label="Target"
                                options={this.state.targetData}
                                handleNewRequest={this.handleSelectTarget}
                                component={renderAutoCompleteSingleSelect}
                                />
                            </div>
                        </div>
                        <Divider/>
                        <div className="row">
                            <div className="mt-30" style={{fontWeight: "bold"}}>Move Program/Target to :</div>
                            <div className="col-sm-12 mt-30">
                                <Field autoFocus={true}
                                    name="moveDomainId"
                                    label="Domain"
                                    options={this.state.domainData}
                                    handleNewRequest={this.handleDomainNameSelection}
                                    disabled={this.state.selectedProgram ? false : true}
                                    component={renderAutoCompleteSingleSelect} />
                            </div>
                            <div className='col-sm-12 mt-30'>
                                <Field
                                name="moveProgramId"
                                label="Program"
                                options={this.state.moveProgramData}
                                handleNewRequest={this.handleProgramNameSelection}
                                disabled ={this.state.targetID? false: true} 
                                component={renderAutoCompleteSingleSelect}
                                />
                            </div>
                            {this.state.programError && <p style={{fontSize: '12px', color: "rgb(244, 67, 54)"}}>No program found under the selected domain.</p>}
                        </div>
                    </form>
                </div>
            </div>
        </Dialog>;
    }
    
}

function mapStateToProps(state) {
    return {
       loading: state.domain.loading || state.skillAcquisitionDomain.loading,
       skillAcquisitionDomainList: state.skillAcquisitionDomain.skillAcquisitionDomainList,
       skillAcquisitionProgramList: state.skillAcquisitionDomain.skillAcquisitionProgramOne,
       skillAcquisitionProgramListing: state.skillAcquisitionDomain.skillAcquisitionProgramTwo,
       skillAcquisitionTargetList: state.skillAcquisitionTarget.skillAcquisitionTargetList,        
    }
}

MoveDomainModal = reduxForm({
    form: 'MoveDomainModalForm',
    validate,
    enableReinitialize: true,
})(MoveDomainModal);

export default connect(mapStateToProps, {getSkillAcquisitionDomainList,getSkillAcquisitionProgramList, getSkillAcquisitionTargetList,movePatientSkillAcquisitionData, getSkillAcquisitionProgramListForMoveData, ResetMoveData})(MoveDomainModal);


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Domain/MoveDomainModal.js